var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-aside',{attrs:{"width":"240px"}},[_c('aside-menu')],1),_c('el-container',[_c('el-header',[_c('header-control')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }